module.exports = __webpack_public_path__ + "img/norway-cerebrovascular-disease-female.1e073302.png";